/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTabPanelProps, TdTabsProps } from './type';

export const tabPanelDefaultProps: TdTabPanelProps = { destroyOnHide: true, removable: false };

export const tabsDefaultProps: TdTabsProps = {
  addable: false,
  dragSort: false,
  placement: 'top',
  size: 'medium',
  theme: 'normal',
};
